import {
  deleteApi,
  getApi,
  patchApi,
  postApi,
  putApi,
} from '../../../utils/api'
import { DOC_FLOW_API_URL } from '../DocFlow.constants'

import { DOC_FLOW_SENDING_TABLE_CONFIG_URL } from './DocFlowSending.constants'
import { getSendingTableApiUrls } from './DocFlowSending.utils'

export function getDocFlowSendingFiles({ data, documentId }) {
  return postApi({
    data,
    endpoint: getSendingTableApiUrls(documentId).listApi,
  })
}

export function updateSendingTableConfig(data) {
  return putApi({
    data,
    endpoint: `${DOC_FLOW_SENDING_TABLE_CONFIG_URL}config/`,
  })
}

export function deleteSendingItem({ documentId, sendingId }) {
  return deleteApi({
    endpoint: `${DOC_FLOW_API_URL}${documentId}/sending-files/${sendingId}/`,
  })
}

export function updateSendingItem({ data, documentId, itemId }) {
  return patchApi({
    data,
    endpoint: `${DOC_FLOW_API_URL}${documentId}/sending-files/${itemId}/`,
  })
}

export function performDocFlowSendingMassAction(documentId, data) {
  return postApi({
    data,
    endpoint: `${DOC_FLOW_API_URL}${documentId}/sending-files/mass-action/`,
  })
}

export function performDocFlowSendingCompositeMassAction(documentId, data) {
  return postApi({
    data,
    endpoint: `${DOC_FLOW_API_URL}${documentId}/sending-files/multi-mass-action/`,
  })
}

export function getDocFlowSendingWidgetProcess(documentId) {
  return getApi({
    endpoint: `${DOC_FLOW_API_URL}${documentId}/sending-files/process/`,
  })
}

export function updateDocFlowSendingFileProcess({ data, id }) {
  return patchApi({
    data,
    endpoint: `${DOC_FLOW_API_URL}${id}/sending-files/process/`,
  })
}

export function getDocFlowSendingFilesByRecipient({ documentId, params }) {
  return getApi({
    endpoint: `${DOC_FLOW_API_URL}${documentId}/recipient-sending-files/`,
    params,
  })
}

export function getDocFlowSendingEpostSettings(documentId) {
  return getApi({
    endpoint: `${DOC_FLOW_API_URL}${documentId}/sending-files/epost-settings/`,
  })
}

export function updateDocFlowSendingEpostSettings({ data, documentId }) {
  return patchApi({
    data,
    endpoint: `${DOC_FLOW_API_URL}${documentId}/sending-files/epost-settings/`,
  })
}

export function calculateDocFlowSendingEpostCost(documentId) {
  return postApi({
    endpoint: `${DOC_FLOW_API_URL}${documentId}/sending-files/calculate-epost-cost/`,
  })
}
